module.exports = __webpack_public_path__ + "static/media/ss11.332992d3.jpg";